import { ApexApiError } from 'apex-ui-services'
import { AxiosResponse } from 'axios'
import { Dispatch } from 'redux'
import { getAccountOwners as getAccountOwnersApi } from '../api'
import { HttpResponseStatusCodes } from '../constants'
import {
  ACCOUNT_OWNERS_RETRIEVAL_FAILED,
  TEMPORARILY_UNAVAILABLE,
} from './constants'

export const GET_ACCOUNT_OWNERS = 'GET_ACCOUNT_OWNERS'
export const GET_ACCOUNT_OWNERS_SUCCESS = 'GET_ACCOUNT_OWNERS_SUCCESS'
export const GET_ACCOUNT_OWNERS_FAILURE = 'GET_ACCOUNT_OWNERS_FAILURE'

export const getAccountOwners = (
  dispatch: Dispatch,
  accountNumber: string,
  onError: (error: string) => void
) => {
  dispatch({ type: GET_ACCOUNT_OWNERS, accountNumber })
  getAccountOwnersApi(accountNumber)
    .then((response: AxiosResponse) => {
      dispatch({
        type: GET_ACCOUNT_OWNERS_SUCCESS,
        accountOwners: response.data,
      })
    })
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      const loadingAccountOwnersError =
        httpResponseStatus &&
        httpResponseStatus >= HttpResponseStatusCodes.InternalServerError
          ? TEMPORARILY_UNAVAILABLE
          : ACCOUNT_OWNERS_RETRIEVAL_FAILED
      dispatch({ type: GET_ACCOUNT_OWNERS_FAILURE })
      onError(loadingAccountOwnersError)
    })
}
